import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter } from '../../../global/commonStyle';

const Header = styled.div`
  padding: var(--space-8) var(--space-12);
  box-shadow: var(--bottom-border);
  ${Typography.body_md}
  color: var(--text-primary);
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  padding: var(--space-4) var(--space-4) var(--space-12);
  .active {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
`;
const Top = styled.div`
  min-width: 238px;
  padding: var(--space-4) var(--space-6);
  border-radius: var(--border-radius-4);
  ${AlignCenter}
  gap: var(--space-10);
  cursor: pointer;
  .mic-stroke-color {
    path {
      stroke: var(--text-primary);
    }
  }
  &:hover {
    background-color: var(--neutral-secondary);
  }
`;
const Text = styled.div`
  ${Typography.body_md}
  color: var(--text-primary);
`;
const ButtonDiv = styled.div`
  padding-inline: var(--space-12);
  .recording-button {
    width: 100%;
  }
`;
export { Header, Bottom, Top, Text, ButtonDiv };
